import Calc from "@/common/util/calculator"
import BaseScrewFixmethod from "@/signomatic/app/fixmethods/base_screw"

export default class ScrewStainlessFixmethod extends BaseScrewFixmethod {
  positions() {
    const { widthPx, heightPx } = this.state
    const positions = []
    const diameter = Calc.mmToPx(3.5)
    const headDiameter = Calc.mmToPx(5)
    const distance = this.state.width < 31 ? Calc.mmToPx(3.63) : Calc.mmToPx(4)

    const left = distance
    const right = widthPx - distance
    const centerV = heightPx / 2
    const flathead = false

    const top = distance
    const bottom = heightPx - distance

    const defaults = { diameter, headDiameter, flathead }

    if (["stainless_28x49", "stainless_30x30"].includes(this.drawables.state.preset || "")) {
      positions.push({ ...defaults, left, top: top })
      positions.push({ ...defaults, left, top: bottom, stretch: true })
    } else if (this.drawables.state.width >= 100) {
      positions.push({ ...defaults, left, top: top })
      positions.push({ ...defaults, left: right, top: top })
      positions.push({ ...defaults, left, top: bottom })
      positions.push({ ...defaults, left: right, top: bottom })
    } else {
      positions.push({ ...defaults, left, top: centerV })
      positions.push({ ...defaults, left: right, top: centerV })
    }

    return positions
  }
}
